// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"style_svgIcon__DNF2K","svgIconed":"style_svgIconed__cd1Th"};